"use client";

import { useEffect } from "react";
import { AlertCircle } from "lucide-react";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <div className="max-w-md w-full bg-white text-black rounded-lg shadow-lg overflow-hidden">
        <div className="p-6 text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-red-100 p-3 dark:bg-red-900/20">
              <AlertCircle
                className="h-8 w-8 text-red-600 dark:text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <h2 className="text-xl sm:text-2xl font-bold mb-2">
            Something went wrong
          </h2>
          <p className=" mb-6">
            We apologize for the inconvenience. An error has occurred while
            processing your request.
          </p>

          {error.digest && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
              Error ID: <code className="font-mono">{error.digest}</code>
            </p>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={reset}
              className="px-4 py-2 bg-themeColor text-white font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
            >
              Try again
            </button>
            <Link
              href="/"
              className="px-4 py-2 border border-themeColor  !text-themeColor font-medium rounded-md hover:!text-white hover:bg-gray-50 dark:hover:bg-themeColor-60 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
            >
              Go back home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
